/**
 * Helper for files
 *
 * @version 1.7.0
 */
const FileHelper = (function () {

    function downloadFile(response){
        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        let fileName = "downloaded-file"; // Default filename

        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/);
            if (filenameMatch) {
                fileName = decodeURIComponent(filenameMatch[1].trim()); // Decode special characters
            }
        }

        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: response.headers["content-type"] });

        // Create a temporary URL and trigger the download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName; // Use extracted filename
        document.body.appendChild(a);
        a.click();

        // Cleanup
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }

    return {
        downloadFile: function (response) {
            return downloadFile(response);
        }
    };
})();

export default FileHelper;